import {Injectable} from '@angular/core';
import {ParametersDatabase} from "../../databases/parameters.database";

@Injectable({
    providedIn: 'root'
})
export class SqliteRoleParameterRepository {

    constructor(private readonly parametersDatabase: ParametersDatabase) {
    }

    async getRoleParameters(): Promise<any> {
        const roleParameters: any[] = await this.parametersDatabase.queryObjects<any>(
            `SELECT *
             FROM roleparameter`,
            null,
            ['value']
        );
        return roleParameters;
    }

}
